var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudio = function SvgAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M6.1 13.9c-.05-3.3-.1-7.2.05-10.6 3.15-.7 6.25-.8 8.95-.4.05 3.3.1 6.9 0 10.3"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M6.2 6.3c3-.6 6.1-.7 8.9-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.75,
    d: "M6.1 13.7c0 1-.7 1.7-1.6 1.8s-1.6-.4-1.6-1.2c0-.9.8-1.6 1.7-1.65s1.5.35 1.5 1.05M15.1 13c0 1-.7 1.7-1.6 1.8s-1.6-.4-1.6-1.2c0-.9.8-1.6 1.7-1.65s1.5.35 1.5 1.05"
  }))));
};
export default SvgAudio;